import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';

export default function CustomSlider({ images }) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Slider
      dots={settings?.dots}
      infinite={settings?.infinite}
      speed={settings?.speed}
      slidesToShow={settings?.slidesToShow}
      slidesToScroll={settings?.slidesToScroll}
      className='SliderProject'
    >
      {images.map((image, index) => (
        <div key={image.id || index}>
          <img src={image.src} alt={`Slide ${index + 1}`} />
        </div>
      ))}
    </Slider>
  );
}

CustomSlider.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      src: PropTypes.string.isRequired
    })
  ).isRequired,
};
